<template>
  <div class="detailPage">
    <!-- <img src="/statics/images/jifen/head.png" class="titleImg"> -->
    <!-- <img src="@/assets/img/head.png" class="titleImg" /> -->
    <div class="titleImgName">《北京市居住证》积分模拟打分计算器</div>
    <div class="titleText">
        <p class="text">依据《北京居住证积分管理办法》新政策条例模拟计算居住证积分</p>
        <p class="prompt">请选择符合您情况的选项或在文本框中填写相应的数字、内容，完成测分后将获得准确积分结果。</p>
        <div class="divTitle">
            <a href="https://www.bjmzw.com/bjluxt/" class="list">
                <div class="num">1</div>
                <div class="name">基础指标</div>
            </a>
            <a href="https://www.bjmzw.com/bjluxt/" class="list">
                <div class="num">2</div>
                <div class="name">加分指标</div>
            </a>
            <a href="https://www.bjmzw.com/bjluxt/" class="list">
                <div class="num">3</div>
                <div class="name">减分指标</div>
            </a>
            <a class="list">
                <div class="num">4</div>
                <div class="name">积分评估</div>
            </a>
            <a class="lists">
                <div class="num">5</div>
                <div class="name">测评分析</div>
            </a>
        </div>
        <div class="titleName">
            测评分析
        </div>
        <div class="resultDiv">
            <p class="result_title">你的测评结果</p>
            <p class="result">分数不够</p>
            <p class="report">测评报告</p>
            <div v-for="(item,index) in tianjin" :key='index'>
                <div class="report_content">
                    <div class="report_title">{{titleContent(item,1)}}</div>
                    <div class="content">
                        <p v-for="(items,index1) in item.text" :key="index1">
                            {{items}}
                        </p>
                    </div>
                </div>
                <div class="lookName">
                    <a :href="titleContent(item,2)">{{titleContent(item,3)}}</a>
                </div>
            </div>
            
        </div>
        <div>

        </div>
    </div>
    
  </div>
</template>

<script>
import tianjin from '@/assets/json/tianjin.json'
export default {
    data(){
        let config = []
        Object.assign(config,tianjin)
        return{
            tianjin:config.data,
            scoreList:[]
        }
    },
    mounted(){
        // console.log(this.tianjin)
        if(localStorage.getItem('hangzhouScore')){
            this.scoreList = JSON.parse(localStorage.getItem('hangzhouScore'))
            this.numContent()
        }
        // console.log(this.tianjin)
    },
    methods:{
        numContent(){
            this.tianjin.forEach(item => {
                this.scoreList.forEach((i) => {
                    if(i.scoreId == item.id){
                        item.num = i.num
                    }
                })
            })
        },
        titleContent(item,type){
            let text = ''
            if(type == 1){
                if(item.num == 0){
                    text = item.content.low.text
                }else{
                    text = item.content.tall.text
                }
            }else if(type == 2){
                if(item.num == 0){
                    text = item.content.low.link
                }else{
                    text = item.content.tall.link
                }
            }else if(type == 3){
                if(item.num == 0){
                    text = item.content.low.name
                }else{
                    text = item.content.tall.name
                }
            }
            
            return text
        }
    }
}
</script>

<style lang="less" scoped>
.detailPage{
    width: 1180px;
    margin: 0 auto;
    position: relative;
    left: 0;
    top: 0;
    .titleImg{
        width: 100%;
        height: 120px;
        position: absolute;
        left: 0;
        right: 0;
    }
    .titleImgName{
        width: 100%;
        height: 120px;
        position: absolute;
        left: 0;
        right: 0;
        z-index: 56;
        line-height: 120px;
        text-align: center;
        color: #ffffff;
        font-weight: bold;
        font-size: 42px;
    }
    .titleText{
        font-size: 14px;
        width: 100%;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
        padding-top: 162px;
        
        .text{
            text-align: center;
            width: 896px;
            margin: 0 auto;
        }
        .prompt{
            text-align: center;
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #DE0A37;
            height: 14px;
            line-height: 14px;
            margin-top: 8px;
        }
    }
    .divTitle{
        display: flex;
        padding: 0 20px;
        justify-content: space-between;
        margin-top: 54px;
        .list{
            width: 200px;
            height: 52px;
            background: #ffffff;
            border: 1px solid #1586dd;
            border-radius: 26px;
            padding: 0 8px;
            display: flex;
            align-items: center;
            text-decoration:none;
            .num{
                width: 36px;
                height: 36px;
                background: #1586DD;
                border-radius: 50%;
                font-size: 22px;
                line-height: 36px;
                text-align: center;
                // margin-left: 8px;
                color: #FFFFFF;
            }
            .name{
                height: 18px;
                font-size: 18px;
                color: #1586DD;
                line-height: 19px;
                margin-left: 10px;
                width: 148px;
                text-align: center;
                // flex: 1;
                // text-align: center;
            }
        }
        .lists{
            width: 200px;
            height: 52px;
            background: #1586DD;
            border: 1px solid #1586DD;
            border-radius: 26px;
            padding: 0 8px;
            display: flex;
            align-items: center;
             .num{
                width: 36px;
                height: 36px;
                color: #1586DD;
                border-radius: 50%;
                font-size: 22px;
                line-height: 36px;
                text-align: center;
                // margin-left: 8px;
                background: #FFFFFF;
            }
            .name{
                height: 18px;
                font-size: 18px;
                color: #FFFFFF;
                line-height: 19px;
                margin-left: 10px;
                width: 148px;
                text-align: center;
                // flex: 1;
                // text-align: center;
            }
        }
    }
    .titleName{
        width: 1121px;
        background: #1586DD;
        margin: 0 auto;
        font-size: 18px;
        font-weight: bold;
        color: #FFFFFF;
        // height: 18px;
        line-height: 18px;
        padding: 23px 0 20px 19px;
        margin-top: 40px;
    }
    .resultDiv{
        margin-top: 41px;
        text-align: center;
        .result_title{
            font-weight: 500;
            font-size: 20px;
            font-weight: 500;
            color: #333333;
        }
        .result{
            font-size: 36px;
            font-weight: bold;
            color: #F6242E;
            margin-top: 36px;
        }
        .report{
            font-size: 20px;
            font-weight: 500;
            color: #333333;
            margin-top: 52px;
            margin-bottom: 20px;
        }
        .report_content{
            width: 1102px;
            background: #FAFAFA;
            text-align: left;
            margin: 0 auto;
            .report_title{
                margin: 0 20px;
                height: 58px;
                // line-height: 58px;
                display: flex;
                align-items: center;
                font-size: 16px;
                font-weight: 500;
                color: #F6242E;
                border-bottom: 1px solid #59A8E5;
            }
            .content{
                padding: 22px 20px;
            }
        }
        .lookName{
            width: 200px;
            height: 40px;
            background: #F6252F;
            // margin: 0 auto;
            margin: 20px auto 40px auto;
            a{  
                display: inline-block;
                font-size: 14px;
                color: #FFFFFF;
                height: 40px;
                line-height: 40px;
                width: 200px;
                text-align: center;
                text-decoration:none
            }
        }
    }
}
</style>